import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app', [
        'ngSentry',
        'ngDialog',
        'ngCookies',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ui.router',
        'toastr',
        'pascalprecht.translate',
        'ngFileUpload',
        'ngFileSaver',
        '720kb.datepicker',
        'angular-clipboard',
        'angular-loading-bar',
        'angucomplete-alt',
        'chart.js',
        'jw.tooltip',
        'ui.timepicker',
        'uiSwitch',
    ]);
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/index.module.ts